<template>
    <div
        class="box-modal fade limit-modal m-ui"
        tabindex="-1"
        data-element="modal-tariff-select"
    >
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" @click="close">
                    <svg class="icon icon--close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--close"></use></svg>
                </button>
            </div>
            <div class="modal-body">
                <div class="fs-lg mb-3" v-html="displayMessage" />
                <div class="fs-xl">{{ vats.name }}</div>
                <div class="fs-xxl nowrap" v-if="vats.price">
                    {{ formatPrice(vats.price) }} <span class="uom text-gray normal">руб.<br>/мес.</span>
                </div>
            </div>
            <div class="modal-footer">
                <Button
                    title="Повысить версию ВАТС"
                    :loading="loading"
                    @click="submit"
                />
                <Button
                    title="Продолжить оформление"
                    :link="true"
                    @click="close"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '../../../components/ui/Button';
import ModelVats from '../models/vats';
import priceFormatter from '../../../lib/priceFormatter.js'

export default {
    name: "ChangeVatsModal",
    components: {
        Button
    },
    props: {
        currentVats: {
            type: ModelVats
        },
        vats: {
            type: ModelVats
        },
        limit: {
            type: Number
        }
    },
    data () {
        return {
            loading: false
        }
    },
    computed: {
        displayMessage () {
            let noticeText = this.currentVats && this.currentVats.name ? 'версии продукта ' + this.currentVats.name : 'выбранной версии продукта';
            return `Для ${ noticeText } установлен лимит номеров - <b>${ this.limit }</b>.<br>
                    Выберите более высокую версию Виртуальной АТС.`
        }
    },
    methods: {
        formatPrice (price) {
            return priceFormatter.format(price)
        },
        close() {
            this.$emit('close');
        },
        submit () {
            if (typeof window.selectVats === 'undefined') {
                return;
            }

            this.loading = true;

            window.selectVats({
                "id":  this.vats.id,
                "redirect": '/shop/numbers/'
            });
        }
    }
}
</script>

<style lang="scss">

</style>